import Form from '@blocks/Form'
import Grid from '@blocks/Grid'
import useAuth from '@hooks/useAuth'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import React from 'react'
import api from '@api'
import Input from '@blocks/Input'
import Select from '@blocks/Select'
import Button from '@blocks/Button'
import useCountries from '@hooks/models/useCountries'
import useTitle from '@hooks/useTitle'
import MainContainer from '@blocks/MainContainer'

export default function DetailsPage() {
    const { user, setUser } = useAuth<Resources.CustomerPartial>()
    
    useTitle("Details")
    useMainTemplate({ category: "details" })

    const { options: countries } = useCountries()

    return (
        <MainContainer heading="Details">
            <Form action={api.details} method="patch" handleSuccess={setUser}>
                <Grid columns="3" gap="30px|60px">
                    <Grid gap="20px">
                        <div>
                            <h3>Personal info</h3>
                            <p>All the information must be written in English. Otherwise, FIAP and PSA will not accept it.</p>
                        </div>
                        {!user.email && (
                            <Input
                                id="email"
                                name="email"
                                type="email"
                                label="Email"
                                placeholder="example@example.com"
                                autoFocus
                                required />
                        )}
                        <Input
                            id="first_name"
                            name="first_name"
                            pattern="^([A-Z][a-zA-Z \-]+|[A-Z])$"
                            title="It's required to use only latin letters. Also, the first letter must be in uppercase."
                            label="First name" 
                            placeholder="John" 
                            defaultValue={user.first_name || undefined}
                            autoFocus={Boolean(user.email)} 
                            required />
                        <Input
                            id="last_name"
                            name="last_name"
                            pattern="^([A-Z][a-zA-Z \-]+|[A-Z])$"
                            title="It's required to use only latin letters. Also, the first letter must be in uppercase."
                            defaultValue={user.last_name || undefined}
                            label="Last name"
                            placeholder="Doe"
                            required />
                    </Grid>
                    <Grid gap="20px">
                        <div>
                            <h3>Postal address</h3>
                            <p>Please, enter your address correctly as it will be used for awards delivery. You need to enter your address only once and it will be used for all salons you participate.</p>
                        </div>
                        <Select id="country_id" name="country_id" label="Country" options={countries} placeholder="Select" required />
                        <Input id="address" name="address" label="Full address" placeholder="France, Paris, 92 Place de la Madeleine" required />
                        <Input id="zip" name="zip" label="ZIP Code" placeholder="75011" required />
                        <hr />
                        <Input id="phone" name="phone" type="tel" label="Phone" optional placeholder="+33 1 09 75 83 51" comment="We will never call you or send spam. The phone will be given to the postal company in order to deliver your package faster. It's not required to provide it." />
                    </Grid>
                    <Grid gap="20px">
                        <h3>Rules</h3>
                        <Input id="fiap_rules" type="checkbox" name="fiap_rules" label={<span>I agree with the <a href="https://www.myfiap.net/documents/FIAP%20DOC%20018%202017%20E.pdf" target="_blank">FIAP document 018/2017 E</a></span>} required />
                        <Button element="submit">Sign up</Button>
                    </Grid>
                </Grid>
            </Form>
        </MainContainer>
    )
}